import { axiosInstance as request } from '@api/rest.service'

const api = '/license-qualifier-labels'

/**
 * @description GET /license-qualifier-labels
 * @returns {AxiosPromise<any>}
 */
export const GET_QUALIFIER_LABELS = () => request.get(api)

/**
 * @description POST /license-qualifier-labels
 * @returns {AxiosPromise<any>}
 */
export const CREATE_QUALIFIER_LABEL = payload => request.post(api, payload)

/**
 * @description PUT /license-qualifier-labels/{id}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_QUALIFIER_LABEL = (id, payload) => request.put(`${api}/${id}`, payload)

/**
 * @description GET /license-qualifier-labels/{id}/delete-confirmation
 * @returns {AxiosPromise<any>}
 */
export const GET_QUALIFIER_LABEL_DELETE_CONFIRMATION = id => request.get(`${api}/${id}/delete-confirmation`)

export const DELETE_QUALIFIER_LABEL = id => request.delete(`${api}/${id}`)
